import React from 'react';
import classNames from 'classnames';

import styles from './buysideConsensusSidebarStyles.scss';

const BuysideConsensusSidebar = ({
  items,
  activeIdx,
  showPriceChart,
  updateActiveIdx,
  returnToPoll
}) => (
  <div className={styles.companyChartSidebar}>
    <h2>Poll Topics</h2>
    <div className={styles.companyChartToggleList}>
      <ul>
        {items.map((item, idx) => (
          <li
            key={idx}
            className={classNames({ [styles.active]: activeIdx === idx && !showPriceChart })}
            onClick={() => {
              updateActiveIdx(idx);
              if (showPriceChart) returnToPoll();
            }}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default BuysideConsensusSidebar;
